module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/incorrectPick-d7118bdd495b37ce4ab1ed1425107cba.svg";